
import React, { useContext } from 'react';
import styled from 'styled-components'
import Logo from '../assets/images/JnPLogo.png'
import { ColorGreyDark, colorTeal, colorPurple } from '../styles/sharedStyles';
import { ChartContext } from '../context/ChartContext';

const CreditContainer = styled.div`
    grid-area: credit;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;

    padding-bottom: 1.5rem;
`

const CreditItem = styled.div`
    display: flex;
    justify-content: ${props => props.justify};
    align-items: center;
    color: ${ColorGreyDark};
    padding-left: ${props => props.paddingLeft || 0}px;

    img {
        height: 2.5rem;
    }

    a {
        color: ${ColorGreyDark};

        &:hover{
            color: ${props => props.color};
        }
    }
`

const Credit = () => {

    const { path } = useContext(ChartContext)
    const hoverColor = path === "hrds" ? colorTeal :  colorPurple

    return ( 
        <CreditContainer>
            <CreditItem
                color={hoverColor}
                paddingLeft={10}
            >
                Designed and built by: 
                <a
                    href="https://twitter.com/AndSzesztai" 
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    &nbsp;András Szesztai
                </a>
            </CreditItem>
            <CreditItem
                    color={hoverColor}
            >
                <a
                    href="https://www.vizforsocialgood.com/" 
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    #VizforSocialGood
                </a>
            </CreditItem>
            <CreditItem>
                Datasource: 
                <a 
                    href="https://www.justiceandpeace.nl/" 
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <img src={Logo} alt="Justice and Peace logo"/>
                </a>
            </CreditItem>
        </CreditContainer>
     );
}
 
export default Credit;